import { get } from 'lodash'

export default function(data) {
  return {
    awardLevel: { value: '' },
    previousCompletedAwardPlace: get(data, 'previousCompletedAwardPlace'),
    previousCompletedAwardLevel: get(data, 'previousCompletedAwardLevel'),
    stateOrProvinceOrRegion: get(data, 'stateOrProvinceOrRegion'),
    employmentStatus: get(data, 'employmentStatus'),
    organizationId: get(data, 'organizationId'),
    nationality: get(data, 'nationality'),
    phoneNumber: get(data, 'phoneNumber'),
    middleName: get(data, 'middleName'),
    phoneType: get(data, 'phoneType'),
    firstName: get(data, 'firstName'),
    countryId: get(data, 'countryId'),
    birthDate: get(data, 'birthDate'),
    lastName: get(data, 'lastName'),
    emailAgain: get(data, 'email'),
    zipCode: get(data, 'zipCode'),
    gender: get(data, 'gender'),
    email: get(data, 'email'),
    line1: get(data, 'line1'),
    line2: get(data, 'line2'),
    title: get(data, 'title'),
    city: get(data, 'city'),
    consentDeliveryType: get(data, 'consentDeliveryType'),
    parentEmail: get(data, 'parentEmail'),
    parentFirstName: get(data, 'parentFirstName'),
    parentLastName: get(data, 'parentLastName'),
    parentPhone: get(data, 'parentPhone'),
    parentRelationship: get(data, 'parentRelationship'),
    postal: {
      line1: get(data, 'postalLine1'),
      line2: get(data, 'postalLine2'),
      city: get(data, 'postalCity'),
      zipCode: get(data, 'postalZipCode'),
      stateOrProvinceOrRegion: get(data, 'postalStateOrProvinceOrRegion'),
      countryId: get(data, 'postalCountryId')
    },
    helpers: {
      isEmailFixed: get(data, 'isEmailFixed'),
      hidePassword: get(data, 'hidePassword'),
      postalAddressChecked:
        get(data, 'postalCountryId') ||
        get(data, 'postalLine1') ||
        get(data, 'postalLine2') ||
        get(data, 'postalZipCode') ||
        get(data, 'postalCity') ||
        get(data, 'postalStateOrProvinceOrRegion')
    }
  }
}
